import { render, staticRenderFns } from "./BlogSocialSettings.vue?vue&type=template&id=75f52c30&scoped=true"
import script from "./BlogSocialSettings.vue?vue&type=script&lang=js"
export * from "./BlogSocialSettings.vue?vue&type=script&lang=js"
import style0 from "./BlogSocialSettings.vue?vue&type=style&index=0&id=75f52c30&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "75f52c30",
  null
  
)

export default component.exports